import {Injectable} from '@angular/core';
import {ListView,TypeComparaison} from "@domain/common/list-view";
import {Balise,TypePorteeBalise} from "@domain/admin/bibliotheque/notification/balise";
import {BaliseItemComponent} from "@components/admin/bibliotheque/notifications/balises/balise-item/balise-item.component";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {Sorting} from "@domain/common/list-view/sorting";

/**
 * Service des balises
 *
 * @author Lionel Gimenez
 * @date 10/03/2026
 */
@Injectable()
export class BalisesService {
    /** Liste des balises */
    listeBaliseView: ListView<Balise, BaliseItemComponent>;

    /**
     * Constructeur
     *
     * @param translateService Service de traduction
     * @param router le routeur Angular
     */
    constructor(
        private translateService: TranslateService,
        private router: Router
    ) { }

    /**
     * Initialisation de la liste
     */
    initListView(): void {
        //Initialisation de la liste des services de niveau 0 pour l'organigramme
        this.listeBaliseView = new ListView<Balise, BaliseItemComponent>({
            uri: `/controller/Notification/listeBaliseNotification`,
            title: this.translateService.instant('admin.bibliotheque.notifications.balise.balisePersonalise'),
            component: BaliseItemComponent,
            isFilter: true,
            defaultOrder: 'nom',
            extraOptions: {
                onSelect: this.select.bind(this),
                isReadOnly: false
            },
            listeFilters: [
                {
                    clef: 'nom',
                    title: this.translateService.instant('admin.bibliotheque.notifications.balise.nom'),
                    isDefault: true,
                    typeComparaison: TypeComparaison[TypeComparaison.LIKE]
                },
                {
                    clef: 'idPortee',
                    title: this.translateService.instant('admin.bibliotheque.notifications.balise.portee'),
                    isDefault: true,
                    typeComparaison: TypeComparaison[TypeComparaison.EQUAL],
                    listeValues: [
                        {code: TypePorteeBalise.NF, libelle: this.translateService.instant('admin.bibliotheque.notifications.balise.portees.NF')},
                        {code: TypePorteeBalise.OD, libelle: this.translateService.instant('admin.bibliotheque.notifications.balise.portees.OD')},
                        {code: TypePorteeBalise.FC, libelle: this.translateService.instant('admin.bibliotheque.notifications.balise.portees.FC')},
                        {code: TypePorteeBalise.AV, libelle: this.translateService.instant('admin.bibliotheque.notifications.balise.portees.AV')},
                        {code: TypePorteeBalise.OT, libelle: this.translateService.instant('admin.bibliotheque.notifications.balise.portees.OT')},
                        {code: TypePorteeBalise.DV, libelle: this.translateService.instant('admin.bibliotheque.notifications.balise.portees.DV')},
                        {code: TypePorteeBalise.IN, libelle: this.translateService.instant('admin.bibliotheque.notifications.balise.portees.IN')}
                    ]
                }
            ]
        });

        //Définition des colonnes de tri
        this.listeBaliseView.columns = [
            { key: 'idPortee', title: 'admin.bibliotheque.notifications.balise.portee'},
            { key: 'nom', title: 'admin.bibliotheque.notifications.balise.nom'}
        ];

        //Ajout du tri de la liste selon l'ordre voulu
        this.listeBaliseView.sorting = new Sorting(this.listeBaliseView.columns, "nom");

        //Persistence des filtres
        this.listeBaliseView.isPersistFilters = true;
        this.listeBaliseView.className = 'BalisesService';
    }

    /**
     * Méthode appelée à la sélection
     *
     * @param deviseSelected Devise sélectionnée
     */
    select(baliseSelected: Balise) {
        //Navigation vers les informations de la devise sélectionnée
        this.router.navigate(['Admin/Bibliotheque/Notification/Balises/' + baliseSelected.idBalise]);
    }

    /**
     * Méthode appelée lors de la création
     */
    create() {
        //Navigation vers le formulaire de création d'une devise
        this.router.navigate(['Admin/Bibliotheque/Notification/Balises/0']);
    }
}